const summary_cards = [
  { label: 'CATEGORY GROUPS', value: '7', note: 'Controlled lists' },
  { label: 'LISTS', value: '29', note: 'Reusable across modules' },
  { label: 'VALUES', value: '148', note: 'Live codes' },
  { label: 'SYNCED MODULES', value: '12', note: 'Depend on master data' }
];

const categories = [
  { title: 'Supplier risk tiers', icon: 'bi-shield-exclamation', meta: '3 values - drives 5 modules', tone: 'warning' },
  { title: 'Risk categories', icon: 'bi-exclamation-triangle', meta: '9 values - drives 3 modules', tone: 'warning' },
  { title: 'Document types', icon: 'bi-file-earmark-text', meta: '8 values - drives 4 modules', tone: 'info' },
  { title: 'Entity / third-party types', icon: 'bi-building', meta: '7 values - drives 3 modules', tone: 'info' },
  { title: 'Obligation sources', icon: 'bi-list-check', meta: '7 values - drives 3 modules', tone: 'success' },
  { title: 'Control frequencies', icon: 'bi-clock', meta: '6 values - drives 3 modules', tone: 'success' },
  { title: 'Cost centres', icon: 'bi-folder', meta: '11 values - drives 3 modules', tone: 'success' }
];

export default {
  name: 'MasterData',
  data: () => ({
    summary_cards,
    categories
  })
};
